import { Box } from '@mui/material'
import { Outlet } from 'react-router'
import Sidebar from './Sidebar'
import TopBar from '../TopBar/TopBar'

/**
 * Desktop layout: permanent sidebar on the left, static top bar + scrollable content on the right.
 */
const DesktopLayout = () => (
    <Box sx={{ display: 'flex', height: '100vh' }}>
        <Sidebar />
        <Box sx={{ flexGrow: 1, display: 'flex', flexDirection: 'column', overflow: 'hidden' }}>
            <TopBar position="static" />
            <Box component="main" sx={{ flexGrow: 1, overflow: 'auto' }}>
                <Outlet />
            </Box>
        </Box>
    </Box>
)

export default DesktopLayout
